
import axios from '../../helpers/axios';


export const updatedMaterial = (id, updateMaterial) => axios.patch(`/material/update/${id}`, updateMaterial)
export const deletedMaterial = (id) => axios.delete(`/material/delete/${id}`)
